import { Pipe, PipeTransform } from '@angular/core';

import { isNumber } from 'lodash-es';

import { selectNonFloatNumberCharacters } from '../../constants/regular-expressions.constant';

type CurrencyInputType = string | number | undefined | null;

const defaultValue = 0;

@Pipe({
  name: 'redTime',
  standalone: false
})
export class TimePipe implements PipeTransform {
  transform(value: CurrencyInputType, unit: string, backupValue: string | number = defaultValue) {
    const number = parseFloat((value?.toString() || '').replace(selectNonFloatNumberCharacters, ''));
    let result = backupValue;

    if (isNaN(number) && isNumber(backupValue)) {
      result = backupValue;
    } else if (!isNaN(number)) {
      result = number;
    }

    return `${result} ${unit}${result === 1 ? '' : 's'}`;
  }
}
